<template>
  <div class="top-card">
    <img class="top-cover" :src="cardData.cover_url" alt="" />
    <div class="top-msg">
      <div class="top-name ellipsis_two">{{ cardData.name }}</div>
      <div class="top-num">{{ cardData.category_name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: {},
      required: true,
      validator: function (value) {
        return value;
      },
    },
  },
  computed: {},
  data() {
    return {};
  },
  onLoad() {},
  methods: {},
};
</script>

<style scoped>
.top-card {
  display: inline-block;
  margin-bottom: 30px;
  /* height: 380px; */
  /* margin-right: 20px; */
}

.top-cover {
  width: 336px;
  height: 189px;
  border-radius: 12px;
  display: block;
  overflow: hidden;
  flex: 0 0 336px;
}

.top-msg {
  height: 140px;
  width: 230px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  padding: 10px 0;
  box-sizing: border-box;
}

.top-name {
  font-size: 28px;
  color: #555;
  line-height: 38px;
  width: 100%;
}

.top-num {
  font-size: 24px;
  color: #555;
  font-weight: 400;
  line-height: 33px;
}

.top-card:nth-of-type(2n) {
  margin-right: 0;
}
</style>>
